import { useState } from "react";
import { useTranslation } from "react-i18next";
import HubView from "@/components/world/HubView";
import MarketView from "@/components/world/MarketView";
import GuildsView from "@/components/world/GuildsView";
import WorldBossView from "@/components/world/WorldBossView";
import RecruitView from "@/components/world/RecruitView";
import ArenaView from "@/components/world/ArenaView";
import RanksView from "@/components/world/RanksView";
import ShopView from "@/components/world/ShopView";
import BiologyView from "@/components/world/BiologyView";
import PartyView from "@/components/world/PartyView";
import FeedView from "@/components/world/FeedView";
import ReferralView from "@/components/world/ReferralView";
import SeasonView from "@/components/world/SeasonView";
import WorkshopView from "@/components/world/WorkshopView";
import TrophyView from "@/components/world/TrophyView";
import SocialView from "@/components/world/SocialView";
import CodexPanel from "@/components/CodexPanel";

// Ordered per player-facing spec (Fase 2). Extras (Party/Feed/Season) trailing.
const SUBS = [
  { id: "hub",       labelKey: "world.hub" },
  { id: "market",    labelKey: "world.market" },
  { id: "shop",      labelKey: "world.shop" },
  { id: "guilds",    labelKey: "world.guilds" },
  { id: "recruit",   labelKey: "world.recruit" },
  { id: "arena",     labelKey: "world.arena" },
  { id: "ranks",     labelKey: "world.ranks" },
  { id: "boss",      labelKey: "world.boss" },
  { id: "workshop",  labelKey: "world.craft" },
  { id: "biology",   labelKey: "world.biology" },
  { id: "trophy",    labelKey: "world.trophy" },
  { id: "referral",  labelKey: "world.refer" },
  { id: "party",     labelKey: "world.party" },
  { id: "feed",      labelKey: "world.feed" },
  { id: "season",    labelKey: "world.season" },
  { id: "social",    labelKey: "world.social" },
];

export default function WorldPanel({ ch, setCh, onBossKilled }) {
  const { t } = useTranslation();
  const [sub, setSub] = useState("hub");
  return (
    <div className="space-y-3">
      <div className="panel p-1 grid grid-cols-4 gap-1" data-testid="world-subnav">
        {SUBS.map(s => (
          <button
            key={s.id}
            data-testid={`world-sub-${s.id}`}
            onClick={() => setSub(s.id)}
            className={`py-2 text-[14px] font-heading tracking-widest uppercase border ${
              sub === s.id ? "border-[#E55A00] text-[#E55A00]" : "border-[#262626] text-[#8c8c8c]"
            }`}
          >
            {t(s.labelKey)}
          </button>
        ))}
      </div>
      {sub === "hub" && <HubView ch={ch} setCh={setCh} />}
      {sub === "party" && <PartyView ch={ch} setCh={setCh} />}
      {sub === "market" && <MarketView ch={ch} setCh={setCh} />}
      {sub === "guilds" && <GuildsView ch={ch} setCh={setCh} />}
      {sub === "boss" && <WorldBossView ch={ch} setCh={setCh} onBossKilled={onBossKilled} />}
      {sub === "recruit" && <RecruitView ch={ch} setCh={setCh} />}
      {sub === "arena" && <ArenaView ch={ch} setCh={setCh} />}
      {sub === "ranks" && <RanksView ch={ch} />}
      {sub === "feed" && <FeedView />}
      {sub === "season" && <SeasonView ch={ch} setCh={setCh} />}
      {sub === "shop" && <ShopView ch={ch} setCh={setCh} />}
      {sub === "workshop" && <WorkshopView ch={ch} setCh={setCh} />}
      {sub === "biology" && <BiologyView ch={ch} setCh={setCh} />}
      {sub === "trophy" && <TrophyView ch={ch} />}
      {sub === "referral" && <ReferralView ch={ch} setCh={setCh} />}
      {sub === "social" && <SocialView ch={ch} setCh={setCh} />}
      {sub === "codex" && <CodexPanel ch={ch} />}
    </div>
  );
}
